var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{attrs:{"direction":"column"}},_vm._l((_vm.faq.data),function(item){return _c('FAQListItem',{key:item.key,attrs:{"item":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }